import { TextField } from "@mui/material";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";
import InputBox from "./InputBox";
import { PField } from "./NestedField";
import { fieldHasError, requiredValidator } from "./validator";

const MaskInput = forwardRef((props, ref) => {
    const { onChange, mask, ...otherProps } = props;

    if (mask) {
        return (
            <IMaskInput
                mask={mask}
                lazy={false}
                inputRef={ref}
                onAccept={(value) => onChange({ target: { name: props.name, value } })}
                {...otherProps}
            />
        );
    } else {
        return <input ref={ref} {...props} />;
    }
});

function maskRequiredValidator(mask) {
    // Se mask for array, pega a primeira máscara
    const maskStr = Array.isArray(mask)
        ? (mask[0]?.mask || '')
        : mask || '';

    // Extrai todos os caracteres fixos da máscara (não placeholders)
    const fixedChars = maskStr.replace(/[#9A-Za-z\*]/g, '');
    return (value) => {
        if (!value) return 'Campo obrigatório';
        let raw = value;
        // Remove todos os caracteres fixos da máscara do valor
        for (const char of fixedChars) {
            raw = raw.split(char).join('');
        }
        // Remove underlines e espaços
        raw = raw.replace(/[_\s]/g, '');
        if (!raw) return 'Campo obrigatório';
        return undefined;
    };
}

export default function TextInput({
    name,
    initialValue,
    required,
    helperText,
    format,
    parse,
    mask,
    sx,
    noUpper,
    onBlur,
    ...props
}) {
    // Se for required e tiver mask, usa validador especial
    const validate = required ? (mask ? maskRequiredValidator(mask) : requiredValidator) : null;
    return (
        <InputBox sx={sx}>
            <PField
                name={name}
                initialValue={initialValue}
                validate={validate}
                format={format}
                parse={parse}
            >
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    return (
                        <TextField
                            variant="standard"
                            required={required}
                            error={hasError}
                            helperText={hasError ? fieldProps.meta.error : helperText}
                            sx={{ flex: 1 }}
                            inputProps={
                                props.type === "email" || noUpper ? {} : {
                                    style: { textTransform: "uppercase" }
                                }
                            }
                            InputProps={
                                mask
                                    ? {
                                        inputComponent: MaskInput,
                                        inputProps:
                                            { mask: mask }
                                    }
                                    : {}
                            }
                            {...fieldProps.input}

                            // código tava causando problemas na edição de texto
                            // tava fazendo o "cursor" cair para o final onChange
                            // onChange={(evt) => {
                            //     let valeu = evt.target.value
                            //     if (props.type !== "email" && valeu) {
                            //         valeu = valeu.toUpperCase();
                            //     }
                            //     fieldProps.input.onChange(valeu)
                            // }}
                            onBlur={(evt) => {
                                let value = evt.target.value
                                if (props.type !== "email" && props.type !== "password" && value && !noUpper) {
                                    value = value.toUpperCase();
                                }
                                fieldProps.input.onChange(value)
                                if (onBlur) {

                                    onBlur(value)
                                }
                            }}
                            {...props}
                        />
                    );
                }}
            </PField>
        </InputBox>
    );
}